import React from 'react'
import { Link } from 'react-router-dom'
import { HomePath } from '../home-path'

export default function Product({ product }) {
  return (
        <div className="aspect-square">
            <a href={HomePath + `/product/${product?.id}/details`} target="_blank" rel="noreferrer noopener">
                <img className="h-full w-full object-cover" src={product?.img} alt="" />
                <div className="py-3 space-y-1">
                    {product?.name && (
                        <p className="font-semibold capitalize text-md md:text-lg truncate">{product?.sex} {product?.name}</p>
                    )}
                    {product?.type && (
                        <p className="capitalize font-medium text-sm md:text-md text-gray-500 truncate">{product?.type}</p>
                    )}
                    {product?.price && (
                        <p className="font-bold truncate">${product?.price}</p>
                    )}
                </div>
            </a>
        </div>
  )
}
